<template>
  <article :class="{ 'slo-tabs': true, underline, [`items-${items}`]: items }">
    <nav>
      <ul ref="ul" v-stack-x:xs>
        <slot />
        <li aria-hidden="true" class="slo-tabs--bar" :style="barStyle"></li>
      </ul>
    </nav>
    <slot name="header" />
    <main v-if="currentTabView && !isFilterTabs" :key="currentTabIndex">
      <component :is="currentTabView" />
    </main>
  </article>
</template>

<script>
export default {
  name: 'SloTabs',
  props: {
    defaultValue: {type: String},
    value: {type: String|Boolean},
    underline: {type: Boolean},
    items: {type: String},
    isFilterTabs: {type: Boolean, required: false}
  },
  data() {
    return {
      internalValue: null,
      listRect: null,
      index: 0,
      currentTabView: null,
      currentTabIndex: -1,
      currentTabRect: null
    };
  },
  watch: {
    value(newValue) {
      if (this.internalValue !== newValue) {
        this.internalValue = newValue;
      }
    }
  },
  created() {
    if (typeof this.value === 'undefined' || !this.value) {
      this.internalValue = this.defaultValue;
    } else {
      this.internalValue = this.value;
    }
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    barStyle() {
      if (!this.currentTabRect) return {};
      const width = `${this.currentTabRect.width}px`;
      const tx = `translateX(${
        this.currentTabRect.left + this.$refs.ul.scrollLeft - this.listRect.left - 10
      }px)`;
      return {width, transform: tx};
    }
  },
  methods: {
    handleResize() {
      this.listRect = this.$refs.ul.getBoundingClientRect();
    },
    onTabChange({name, component, index, rect}) {
      this.$emit('input', name);
      this.internalValue = name;
      this.currentTabView = component;
      this.currentTabIndex = index;
      this.currentTabRect = rect;
    }
  }
};
</script>

<style lang="scss">
@import '../../scss/system';

slo-tabs {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;

  @include screen(sm) {
    align-items: center;
  }
}
</style>

<style lang="scss">
@import '../../scss/system';

.slo-tabs {
  nav > ul {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 15px;
    border-bottom: 1px solid transparent;
    overflow-y: hidden;
    overflow-x: auto;

    @include screen(sm) {
      justify-content: center;
    }

    & > li {
      list-style: none;
    }
  }

  &.underline {
    nav > ul {
      border-bottom: 1px solid $color-gray-400;
    }
  }

  &.items-start {
    nav > ul {
      justify-content: flex-start;
    }
  }

  &.items-end {
    nav > ul {
      justify-content: flex-end;
    }
  }

  main {
    margin-top: 0;
    justify-self: stretch;
    overflow: hidden;
  }
}

.slo-tabs--bar {
  position: absolute;
  bottom: -1px;
  left: 0;
  border: 1px solid $color-blue-400;
  height: 1px;
  transition: transform 250ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
</style>
